import { render, staticRenderFns } from "./ProfileEditHistoryDialog.vue?vue&type=template&id=badd90fa"
import script from "./ProfileEditHistoryDialog.vue?vue&type=script&lang=js"
export * from "./ProfileEditHistoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports